// FT-167. Признак «прайс не заполнен» считает бэкенд (поле price_gaps), здесь
// только показ и локальный пересчёт в карточке.
export const PRICE_GAP_TYPES = ["daily", "hourly", "weekly", "monthly"];

export function hasPriceGaps(gaps) {
  return Array.isArray(gaps) && gaps.length > 0;
}

// Возвращаем МАССИВ строк, а не готовый текст: все три экрана рисуют его
// построчно внутри Vuetify-тултипа (<div> на строку), поэтому склейка и любой
// разделитель — забота разметки, не утилиты.
//
// Отдельные ключи на тип, без подстановки {type} внутрь фразы: в 16 локалях
// склонение названия типа внутри предложения даёт кривые формы — тот же вывод,
// что у FT-166 (bookings.quote_no_price_hourly и соседи).
export function priceGapsLines(gaps, t) {
  if (!hasPriceGaps(gaps)) return [];
  return [
    t("cars.price_gaps_title"),
    ...PRICE_GAP_TYPES.filter((type) => gaps.includes(type)).map((type) =>
      t(`cars.price_gap_${type}`)
    ),
  ];
}

// Зеркало серверного Pricing::PriceGaps.values_filled? — для пересчёта признака
// в карточке без похода на сервер (REQ-06). Расхождение с сервером означало бы,
// что иконка гаснет не тогда, когда дыра действительно закрыта (FM-05), поэтому
// правило повторяется один в один: базовая строка с максимальным id, values
// непуст, без null, есть значение > 0.
//
// НЕ переиспользуем hasUsableBasePrices из bookingQuote.js (FT-166) намеренно:
// он берёт последнюю строку В ПОРЯДКЕ МАССИВА и не проверяет null. Совпадает с
// «последняя по id» только если сервер отдал строки по возрастанию id, что ничем
// не гарантировано — has_many идёт без order, а Postgres меняет порядок после
// UPDATE. Расхождение зафиксировано в FM-05 как находка по FT-166.
export function hasUsableBase(rows) {
  if (!Array.isArray(rows)) return false;
  const base = rows
    .filter((row) => row && row.season_id == null)
    .sort((a, b) => (a.id || 0) - (b.id || 0))
    .pop();
  const values = base && Array.isArray(base.values) ? base.values : null;
  if (!values || values.length === 0) return false;
  if (values.some((v) => v == null)) return false;
  return values.some((v) => Number(v) > 0);
}
